/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION GENERAL SECTION MEDIA COMMENTS: STYLES --------------- ++++++++++ */
export default theme => ({
  placements: {
    '& .sectiongroupv2 > .header': {
      width: '100%'
    },
    '& .configtoggle': {
      '& > .content': {
        borderLeft: 'none',
        paddingLeft: '48px'
      }
    },
    '& .disabled': {
      pointerEvents: 'none',
      opacity: 0.3
    },
    '& .previewconfig': {
      maxWidth: '500px',
      '&.mobile': { maxWidth: '250px'},
      '& .loadmorebutton': {
        background: '#000', 
        color: '#FFF', 
        borderRadius: '30px', 
        height: '40px', 
        width: '220px', 
        fontWeight: 600,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      '& .insticator-logo': {
        width: '200px',
        height: '20px'
      },
      '& .divider': { background: '#000', height: '2px', width: '100%' },
      '& h3': {
        fontFamily: '"Source Serif Pro",serif',
      },
      '& .placeholder': {
        background: '#EEEFF1', 
        borderRadius: '8px', 
        height: '10px',
        color: '#CDCDCD',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: 600,
        '&.rounded': {
          width: '18px', 
          height: '18px', 
          borderRadius: '40px' 
        }
      }
    }
  }
});
